import type { ApiClient } from "./lib/api";
import { AssetsProvider } from "./lib/assets";
import { PublishingProvider, SiteStatus } from "./lib/publishing";
import { AssetsPage } from "./pages/AssetsPage";
import type { Auth } from "./lib/auth";
import { useRoute } from "./lib/router";
import { ExhibitionEditor } from "./pages/ExhibitionEditor";
import { ListPage } from "./pages/ListPage";
import { WorkEditor } from "./pages/WorkEditor";

export function App({ api, auth, mediaBaseUrl }: { api: ApiClient; auth: Auth; mediaBaseUrl: string }) {
  const [section = "works", id] = useRoute();
  const editorId = id === "new" ? undefined : id;

  return (
    <PublishingProvider api={api}>
    <AssetsProvider api={api} mediaBaseUrl={mediaBaseUrl}>
    <div className="app">
      <header className="topbar">
        <strong>Yushi Ouchida — Admin</strong>
        <nav>
          <a href="#/works" className={section === "works" ? "active" : ""}>
            Works
          </a>
          <a href="#/exhibitions" className={section === "exhibitions" ? "active" : ""}>
            Exhibitions
          </a>
          <a href="#/assets" className={section === "assets" ? "active" : ""}>
            Assets
          </a>
        </nav>
        <SiteStatus />
        <span className="user">
          {auth.userLabel()}{" "}
          <button type="button" onClick={() => auth.signOut()}>
            ログアウト
          </button>
        </span>
      </header>
      <main>
        {section === "works" && !id && <ListPage title="Works" basePath="works" load={api.listWorks} />}
        {section === "works" && id && <WorkEditor key={id} api={api} id={editorId} />}
        {section === "exhibitions" && !id && <ListPage title="Exhibitions" basePath="exhibitions" load={api.listExhibitions} />}
        {section === "exhibitions" && id && <ExhibitionEditor key={id} api={api} id={editorId} />}
        {section === "assets" && <AssetsPage api={api} />}
        {!["works", "exhibitions", "assets"].includes(section) && <p>ページが見つかりません。</p>}
      </main>
    </div>
    </AssetsProvider>
    </PublishingProvider>
  );
}
